/**
 * Registro de componentes de preguntas
 *
 * Este archivo centraliza el registro de todos los componentes de preguntas.
 * Para agregar un nuevo tipo de pregunta, simplemente agrega una nueva línea
 * de registro aquí, sin necesidad de modificar QuestionRenderer.
 */

import { questionComponentRegistry } from '@/services/questionComponentRegistry'

/**
 * Registrar todos los componentes de preguntas
 */
export function registerQuestionComponents() {
  // ===== Tipos simples =====
  questionComponentRegistry.register('essay',
    () => import('./simple/EssayQuestion.vue'))

  questionComponentRegistry.register('true_false',
    () => import('./simple/TrueFalseQuestion.vue'))

  questionComponentRegistry.register('single_choice',
    () => import('./simple/ChoiceQuestion.vue'))

  questionComponentRegistry.register('multiple_choice',
    () => import('./simple/ChoiceQuestion.vue'))

  // ===== Tipos especializados =====
  questionComponentRegistry.register('fill_blank',
    () => import('./specialized/FillBlankQuestion.vue'))

  questionComponentRegistry.register('matching',
    () => import('./specialized/MatchingQuestion.vue'))

  questionComponentRegistry.register('table_matrix',
    () => import('./specialized/TableMatrixQuestion.vue'))

  // ===== Tipos con justificación =====
  questionComponentRegistry.register('true_false_justify',
    () => import('./simple/TrueFalseJustifyQuestion.vue'))

  // ===== Tipos con imagen =====
  questionComponentRegistry.register('fill_blank_image',
    () => import('./specialized/FillBlankImageQuestion.vue'))

  console.log('[QuestionComponents] Registered', questionComponentRegistry.getAllTypes().length, 'question types')
}
